import React, { useCallback, useState } from "react";
import { Container, RateButton, RateComponent } from "./index.styled";
import { NpsComponentGenericProps } from "../..";
import { Text } from "../../../common";
import { useTheme } from "styled-components";

const INDEX_LIST: number[] = [1,2,3,4,5,6,7,8,9,10];

const NpsComponent: React.FC<NpsComponentGenericProps> = ({ question, setAnswer }) => {
  const theme = useTheme();
  const [selected, setSelected] = useState<number>(0);

  const handleSetAnswer = useCallback((answer: number) => {
    setAnswer({
      question_id: question.id,
      answer: answer,
    });
    setSelected(answer);
  }, [question, setAnswer]);

  return (
    <Container>
      <Text
        fontSize={16}
        fontWeight={600}
        color={theme.colors.primaryBlue.main}
      >
        {question.label}
      </Text>
      <RateComponent>
        {INDEX_LIST.map((i) => (
          <RateButton
            key={i}
            className={`btn-${i}`}
            selected={selected === i || !selected}
            onClick={() => handleSetAnswer(i)}
          >
            {i}
          </RateButton>
        ))}
      </RateComponent>
    </Container>
  );
};

export default NpsComponent;
